<div class="dispatch-trips-page">
  <legend>Dispatch Trips</legend>

  <lgt-grid-static
    [cols]="cols"
    [data]="trips"
    [selectCol]="true"
    [onDblClick]="viewDetail"
    [showPrintInvoice]="false"
    [showNewButton]="true"
    [newButtonOptions]="newButtonOptions"
    [newButtonAction]="newButtonAction"
    [filters]="filters"
    [loadData]="loadData"
    [showExcelButton]="false"
    [useSignalR]="false"
    [pageName]="'dispatch-trips'"
    [showEmailButton]="true"
    [assignmentDrivers]="assignmentDrivers"
    [driverCardDataCache]="driverCardDataCache"
    (onAssignDriver)="onAssignDriverInline($event)"
    (onEmailTrips)="onEmailSelectedTrips($event)"
  />
</div>

<!-- Create/Edit Modal -->
<app-dispatch-trip-modal
  *ngIf="showModal"
  [tripId]="selectedTripId"
  [visible]="showModal"
  (saved)="onModalSaved($event)"
  (cancelled)="onModalCancelled()"
></app-dispatch-trip-modal>

<!-- Email Preview Modal -->
<app-email-preview-modal
  [(visible)]="showEmailPreviewModal"
  [emails]="emailPreviewItems"
  (confirmed)="onEmailPreviewConfirmed()"
  (cancelled)="onEmailPreviewCancelled()"
></app-email-preview-modal>
